import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

/**
 * Vision Configuration management routes (P22-01) — platform Super User only.
 * Mirrors RoleService.canAccessVisionConfiguration / backend IsVisionConfigurationEditor.
 */
@Injectable({
    providedIn: 'root',
})
export class VisionConfigurationAccessGuardService implements CanActivate {
    constructor(
        private auth: AuthService,
        private router: Router,
        private roleService: RoleService,
    ) {
    }

    canActivate(): boolean {
        if (!this.auth.isAuthenticated()) {
            void this.router.navigate(['/login']);
            return false;
        }

        const userInfo = this.auth.getCurrentUserInfo();
        const groups = userInfo?.role;

        if (this.roleService.canAccessVisionConfiguration(groups)) {
            return true;
        }

        this.router.navigate([this.roleService.getDefaultRoute(groups)]);
        return false;
    }
}
